const products = [
  {
    id: "action-pro",
    images: [
      require("../assets/images/product1/1.png"),
      require("../assets/images/product1/2.png"),
      require("../assets/images/product1/3.png"),
      require("../assets/images/product1/4.png"),
    ],
  },
  {
    id: "action-wi",
    images: [require("../assets/images/product2/1.png")],
  },
  {
    id: "smart-toilet",
    images: [require("../assets/images/product3/1.png")],
  },
  {
    id: "life-sense",
    images: [
      require("../assets/images/product4/1.png"),
      require("../assets/images/product4/2.png"),
      require("../assets/images/product4/3.png"),
      require("../assets/images/product4/4.png"),
      require("../assets/images/product4/5.png"),
    ],
  },
  {
    id: "esg-display",
    images: [
      require("../assets/images/product5/1.png"),
      require("../assets/images/product5/2.png"),
      require("../assets/images/product5/3.png"),
    ],
  },
  {
    id: "wayfinding",
    images: [
      require("../assets/images/product6/1.png"),
      require("../assets/images/product6/2.png"),
    ],
  },
];

export default products;
